// extracted by mini-css-extract-plugin
export default {"memoryIconFieldCropContainer":"MemoryIconUploader_memoryIconFieldCropContainer__qN7Dh","memoryIconUploaderBackdrop":"MemoryIconUploader_memoryIconUploaderBackdrop__FIqN1"};